import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import sentry from '@/services/sentry'

const countingEntries = ({
  slide, perAnswerValue = true, histogram = false, answerer = false,
}) => {
  const base = { slideId: slide.id, slideVersion: slide.version }
  const keys = [CountingSchemes.answerCountPerActivity(base)]
  const groups = []
  if (perAnswerValue && !histogram) {
    groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  if (answerer) {
    keys.push(CountingSchemes.answererCountPerQuestion({ ...base, questionId: 0 }))
  }
  if (histogram) {
    groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  return { keys, groups }
}

const SEED_RETRIES = 1

const report = (error) => sentry.captureException(error)

const reportTruncated = ({ path, count }) => report(
  new Error(`counting seed truncated at ${count} rows: ${path}`),
)

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters }, payload) => {
    if (!payload?.slide?.id || !getters.canUseKvSyncLiveStats) return
    try {
      dispatch('counting/subscribe', {
        ...countingEntries(payload),
        retries: SEED_RETRIES,
        onError: report,
        onTruncated: reportTruncated,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch }, payload) => {
    if (!payload?.slide?.id) return
    try {
      dispatch('counting/unsubscribe', countingEntries(payload), { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
